module.exports = __webpack_public_path__ + "static/media/bg_5.6070afc3.png";